import { render, staticRenderFns } from "./collectActive.vue?vue&type=template&id=cd2a3a90&scoped=true&"
import script from "./collectActive.vue?vue&type=script&lang=js&"
export * from "./collectActive.vue?vue&type=script&lang=js&"
import style0 from "./collectActive.vue?vue&type=style&index=0&id=cd2a3a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2a3a90",
  null
  
)

export default component.exports